import {
  ACCOUNT_SERVICE,
  API_VERSION,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_VARIANCES = `${ACCOUNT_SERVICE}/variances`;

export const variances = {
  getOrderVariances: async ({
    orderId,
    filters,
    sort,
    params,
    signal,
  } = {}) => {
    const options = await apiOptions({
      url: `${API_VARIANCES}/orders/${orderId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
};
